<ng-select
  [ngClass]="{ 'form-control-sm': small }"
  [items]="options"
  bindValue="id"
  bindLabel="ragsociale"
  [(ngModel)]="agent"
  (ngModelChange)="onChange.emit($event)"
  [disabled]="disabled"
  [loading]="loading"
  loadingText="Caricamento..."
></ng-select>
